import { ELayerType } from '@/src/types/common/module';
import { LayerField } from '../util';
import i18n from '../i18n';

export type LayerTemplate = {
  left: Array<LayerProps>;
  right: Array<LayerProps>;
};

export type LayerProps = {
  field: LayerField;
  options?: Array<any>;
};

export const getLayerTemplate = (layerValue: any): LayerTemplate => {
  if (Object.keys(layerValue || {}).length === 0) {
    return {
      left: [],
      right: [],
    };
  }

  const rightSide = [
    { field: LayerField.PositionOption },
    { field: LayerField.EntraceEffect },
  ];

  let leftSide: Array<LayerProps> = [
    {
      field: LayerField.LayerType,
      options: [
        { label: i18n['general.layer.image'], value: ELayerType.IMAGE },
        { label: i18n['general.layer.button'], value: ELayerType.BUTTON },
        { label: i18n['general.layer.text'], value: ELayerType.TEXT },
      ],
    },
  ];

  switch (layerValue?.layerType) {
    case ELayerType.IMAGE: {
      leftSide = [
        ...leftSide,
        { field: LayerField.Image },
        { field: LayerField.ImageWidth },
      ];
      break;
    }
    case ELayerType.BUTTON: {
      leftSide = [...leftSide, { field: LayerField.ButtonTheme }];
      break;
    }
    case ELayerType.TEXT: {
      leftSide = [
        ...leftSide,
        { field: LayerField.Text },
        { field: LayerField.TextWidth },
      ];
    }
  }
  return {
    left: leftSide,
    right: rightSide,
  };
};
